import * as React from 'react';
import * as ReactDom from 'react-dom';
import { RCUtils } from './../../RCUtils';
import $ from 'jquery';
var Config: any = require('../../Config.json');

export interface manageControllerSetting {   
    IsCommandIssued: boolean;
    PrevSelectedItems: any[];
}


export class PopupConfirm extends React.Component<any, any>{

    constructor(props: any) {
        super(props);

        this.state = { IsCommandIssued: false, PrevSelectedItems: [] };        
    }
  
    confirmSubmit() {
     
        var filters = this.props.ForwardCommandUnits();

        if (filters != null) {
            var unitMasterId = filters[0].UnitMasterID;          
            var filterParams = JSON.stringify(unitMasterId);
            //var request = RCUtils.FetchRequest('http://localhost:18362/api/reeferstatus/ManageControllerFlag', {

            //    method: 'POST', body: filterParams, headers: {
            //        'Accept': 'application/json', 'Content-Type': 'application/json'
            //    }
            //});
            //fetch(request).then(response => response.json() as Promise<string>)
            //    .then(data => {                  
            //        $("#Hide_swap").click();
            //        this.props.refreshStatusGrid();
            //    });    var request = RCUtils.FetchRequest(url, { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });

            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/ManageControllerFlag', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<string>)
                .then(data => {
                    $("#Hide_swap").click();
                    this.setState({ IsCommandIssued: true, PrevSelectedItems: this.props.reeferData }, () => { this.props.IsCommandIssued(this.state.IsCommandIssued); this.props.PrevSelectedItems(this.props.reeferData) });
                    this.props.refreshStatusGrid();                    
                });

        }
    }
        render() {
        return (
            <div className="main-container">
                <section className="section1">
                    <div className="center">
                        <div className='modal-controls-container'>Please click ok if you like to confirm controller swap</div>
                        <div className='modal-controls-container'>Note: Users will be able to issue Forward Command once you confirm controller swap</div>
                        <div className="modal-footer">
                           
                            <button type="button" id="Hide_swap" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                            <button type="button" className="btn btn-primary" onClick={this.confirmSubmit.bind(this)}>Ok</button>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
} 
